import { useEffect, useState } from "react";
import { endpoints } from "../lib/api";
import { CaretDown, MagnifyingGlass } from "@phosphor-icons/react";

const fmt = (n, d = 2) =>
  n === undefined || n === null
    ? "-"
    : Number(n).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });

export const SymbolSelector = ({ value, onChange }) => {
  const [symbols, setSymbols] = useState([]);
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  useEffect(() => {
    endpoints
      .symbols(100)
      .then((r) => setSymbols(r.data.symbols || []))
      .catch(() => setSymbols([]));
  }, []);

  const current = symbols.find((s) => s.symbol === value);
  const filtered = symbols.filter((s) =>
    s.symbol.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="relative">
      <button
        data-testid="symbol-selector"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 border border-border px-3 py-2 rounded-sm bg-[#0d0d0d] hover:bg-[#141414] min-w-[220px]"
      >
        <span className="font-heading font-bold text-sm">{value || "Select"}</span>
        {current && (
          <span
            className={`font-mono text-[11px] ${
              current.price_change_pct >= 0 ? "text-signal-buy" : "text-signal-sell"
            }`}
          >
            {current.price_change_pct >= 0 ? "+" : ""}
            {current.price_change_pct.toFixed(2)}%
          </span>
        )}
        <CaretDown size={12} className="ml-auto text-muted-foreground" />
      </button>
      {open && (
        <div className="absolute z-30 mt-1 w-[320px] max-h-[400px] overflow-y-auto border border-border bg-[#0a0a0a] rounded-sm shadow-xl">
          <div className="p-2 border-b border-border sticky top-0 bg-[#0a0a0a]">
            <div className="flex items-center gap-2 bg-[#151515] px-2 py-1 rounded-sm">
              <MagnifyingGlass size={12} className="text-muted-foreground" />
              <input
                data-testid="symbol-search"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search 100 futures pairs..."
                className="bg-transparent outline-none text-xs w-full font-mono"
                autoFocus
              />
            </div>
          </div>
          {filtered.map((s) => (
            <button
              key={s.symbol}
              data-testid={`symbol-option-${s.symbol}`}
              onClick={() => {
                onChange(s.symbol);
                setOpen(false);
                setQuery("");
              }}
              className={`w-full flex items-center justify-between px-3 py-2 text-left hover:bg-[#141414] ${
                s.symbol === value ? "bg-[#151515]" : ""
              }`}
            >
              <span className="font-heading text-sm">{s.symbol}</span>
              <div className="text-right">
                <div className="font-mono text-[11px]">${fmt(s.last_price, s.last_price < 1 ? 6 : 2)}</div>
                <div
                  className={`font-mono text-[10px] ${
                    s.price_change_pct >= 0 ? "text-signal-buy" : "text-signal-sell"
                  }`}
                >
                  {s.price_change_pct >= 0 ? "+" : ""}
                  {s.price_change_pct.toFixed(2)}%
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SymbolSelector;
